import { jsx as _jsx } from "react/jsx-runtime";
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react-lite';
import { Column } from '~/views/atoms/boxes';
import { FormikRadioGroup } from '~/views/atoms/formik-radio-group';
import { useService } from '~/services/service.base';
import { ServiceSorting } from '~/services/service.sorting';
export const FormSortingPanel = observer(() => {
    const formik = useFormikContext();
    const sortingService = useService(ServiceSorting);
    return (_jsx(Column, { gap: 2, children: _jsx(FormikRadioGroup, { options: sortingService.options, formikProps: formik, name: 'sortingOption', label: 'CATEGORY_SORTING_PANEL_SORTING_BY', defaultValue: formik.initialValues.sortingOption }) }));
});
